import { ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import ringersWesternCampaign from "@/assets/clients/ringers-western-campaign.webp";

const FeaturedClientSpotlight = () => {
  const services = ["OmmniFlow", "PIM", "Inventory", "Order Management", "DAM"];

  return (
    <section className="relative py-6 px-4 overflow-hidden" aria-label="Featured client showcase">
      {/* Background Elements */}
      <div className="absolute inset-0 bg-gradient-to-b from-background via-muted/20 to-background" aria-hidden="true" />
      <div className="absolute top-0 right-0 w-96 h-96 bg-primary/5 rounded-full blur-3xl" aria-hidden="true" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-accent/5 rounded-full blur-3xl" aria-hidden="true" />
      
      <div className="container mx-auto relative z-10">
        <header className="text-center mb-12">
          <h2 className="text-sm font-medium text-muted-foreground uppercase tracking-wider mb-2">
            Client Spotlight
          </h2>
          <h3 className="text-3xl md:text-4xl font-bold text-foreground">
            Ringers Western
          </h3>
        </header>

        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center">
            {/* Image Section */}
            <div className="relative group">
              <div className="absolute inset-0 bg-gradient-to-br from-primary/20 to-accent/20 rounded-lg blur-xl group-hover:blur-2xl transition-all duration-300" aria-hidden="true" />
              <div className="relative overflow-hidden rounded-lg shadow-2xl">
                <img
                  src={ringersWesternCampaign}
                  alt="Ringers Western - Australian western clothing brand showcasing their product line"
                  className="w-full h-auto object-cover transform group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                  width={800}
                  height={533}
                />
              </div>
            </div>

            {/* Content Section */}
            <div className="space-y-6">
              <p className="text-lg text-muted-foreground leading-relaxed">
                Ringers Western is an Australian western clothing and lifestyle brand that originated in the Kimberley region of Western Australia in 2012. The brand is known for its durable and comfortable clothing, designed for rural and outdoor life, with products including work shirts, t-shirts, and trucker caps. It was founded by a group of friends who needed high-quality clothing for their work, and the brand is inspired by its rural roots.
              </p>

              <div>
                <h4 className="text-sm font-semibold text-foreground uppercase tracking-wider mb-3">
                  Services Utilized
                </h4>
                <div className="flex flex-wrap gap-2">
                  {services.map((service, index) => (
                    <Badge
                      key={index}
                      variant="secondary"
                      className="px-3 py-1 text-sm"
                    >
                      {service}
                    </Badge>
                  ))}
                </div>
              </div>

              <Button
                asChild
                variant="default"
                size="lg"
                className="group"
              >
                <a
                  href="https://www.ringerswestern.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2"
                >
                  Visit Website
                  <ExternalLink className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                </a>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturedClientSpotlight;
